//#region src/aramark_activate_menu_section_source.ts
var AramarkActivateMenuSectionSource = /* @__PURE__ */ function(AramarkActivateMenuSectionSource) {
	AramarkActivateMenuSectionSource["FamilyGroup"] = "family-group";
	AramarkActivateMenuSectionSource["Slu"] = "slus";
	AramarkActivateMenuSectionSource["Both"] = "both";
	return AramarkActivateMenuSectionSource;
}(AramarkActivateMenuSectionSource || {});
//#endregion
export { AramarkActivateMenuSectionSource };

//# sourceMappingURL=aramark_activate_menu_section_source.js.map